import type { ReceiptTemplate } from '../schema';

export const timHortonsTemplate: ReceiptTemplate = {
  id: 'tim-hortons',
  name: 'Tim Hortons Receipt',
  brand: 'TIM HORTONS',
  description: 'Tim Hortons coffee and donuts receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'tim-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/tim-hortons.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, ON M5V 1A1',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tim-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '01/04/2026 7:30 AM\nORDER #847',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'tim-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'LARGE DOUBLE DOUBLE', quantity: '1', price: '2.29', sku: '' },
          { id: '2', name: 'BOSTON CREAM DONUT', quantity: '2', price: '1.49', sku: '' },
          { id: '3', name: 'SAUSAGE EGG BISCUIT', quantity: '1', price: '4.99', sku: '' },
          { id: '4', name: 'HASH BROWN', quantity: '1', price: '1.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tim-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '12.25', isBold: false, isLarge: false },
          { id: 'hst', label: 'HST (13%)', value: '1.59', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '13.84', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tim-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tim-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'TIMS REWARDS MEMBER\n\nALWAYS FRESH\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

